import React from 'react';
import { useIntl } from 'react-intl';

import { formatEmployeesNumber, formatAmount } from '@xingternal/pages-common';

import EntityInfo from './EntityInfo';

import kununuLogo from '@common/assets/kununuLogo.svg';

import { EntityInfoContainerProps } from '../types';

import styles from './EntityInfo.css';

const EntityInfoCompany = ({
  condensed,
  headerContent,
  showKununu,
}: EntityInfoContainerProps) => {
  if (headerContent?.__typename !== 'EntityPageCompanyHeaderContent') {
    return null;
  }

  const intl = useIntl();

  const entityInfoData = [];
  const companySizeRange = headerContent.company?.companySizeRange;
  const employeesCount = headerContent.company?.employeesCount;
  const kununuData = headerContent.company?.kununuData;
  const followersTotal = headerContent.followers?.total || 0;
  const roundedKununuRating =
    showKununu && kununuData && kununuData.ratingAverage
      ? (Math.round(kununuData.ratingAverage * 10) / 10).toFixed(1)
      : null;

  if (followersTotal > 0) {
    entityInfoData.push({
      value: formatAmount({ value: followersTotal, intl }),
      label: ` ${intl.formatMessage({
        id: followersTotal > 1 ? 'EP_FOLLOWERS.other' : 'EP_FOLLOWERS.one',
      })}`,
      testId: 'HEADER_FOLLOWERS_TOTAL',
    });
  }

  if (companySizeRange && companySizeRange.min !== companySizeRange.max) {
    entityInfoData.push({
      value: formatEmployeesNumber(companySizeRange, intl),
      label: ` ${intl.formatMessage({ id: 'EP_EMPLOYEES' })}`,
      className: !roundedKununuRating ? 'hideBorderOnLowRes' : undefined,
    });
  }

  if (
    companySizeRange &&
    companySizeRange.min !== companySizeRange.max &&
    employeesCount
  ) {
    entityInfoData.push({
      value: formatAmount({ value: employeesCount, intl }),
      label: ` ${intl.formatMessage({ id: 'EP_ON_XING' })}`,
      className: 'hideOnLowRes',
    });
  }

  if (roundedKununuRating && parseFloat(roundedKununuRating) > 0) {
    entityInfoData.push({
      value: (
        <>
          {intl.locale === 'de'
            ? roundedKununuRating.replace('.', ',')
            : roundedKununuRating}
          <span className={styles.kununuRatingLabel}>/5</span>
        </>
      ),
      label: (
        <img src={kununuLogo} className={styles.kununuLogo} alt="Kununu logo" />
      ),
    });
  }

  return <EntityInfo data={entityInfoData} condensed={condensed} />;
};

export default EntityInfoCompany;
